export const ISSUER_PROJECT = {
  CERTIFY: "certify",
  SUNBIRD_RC: "sunbird-rc",
};

export const CREDENTIAL_FORMAT = {
  W3C_VC: "w3c_vc",
  MSO_MDOC: "mso_mdoc",
};

export const CREDENTIAL_FORMAT_OPTIONS = [
  CREDENTIAL_FORMAT.W3C_VC,
  CREDENTIAL_FORMAT.MSO_MDOC,
];

export function parseIssuerProject(data) {
  const project = data?.data?.issuer_project ?? data?.issuer_project ?? "";
  if (
    project === ISSUER_PROJECT.CERTIFY ||
    project === ISSUER_PROJECT.SUNBIRD_RC
  ) {
    return project;
  }
  return null;
}

export function getCredentialFormatLabel(format, t) {
  if (format === CREDENTIAL_FORMAT.W3C_VC) {
    return t("certificateOnboarding:credential_format_display_w3c_vc");
  }
  if (format === CREDENTIAL_FORMAT.MSO_MDOC) {
    return t("certificateOnboarding:credential_format_display_mso_mdoc");
  }
  return "";
}

export function buildCertificateCleanupPayload({
  issuerProject,
  credentialFormat,
  metadata,
  assets,
  fontStylesUrl,
  getAssetUrl = (asset) => asset?.file_url || asset?.url || "",
}) {
  if (
    issuerProject !== ISSUER_PROJECT.CERTIFY &&
    issuerProject !== ISSUER_PROJECT.SUNBIRD_RC
  ) {
    throw new Error("A supported issuer project is required");
  }
  if (issuerProject === ISSUER_PROJECT.CERTIFY && !credentialFormat) {
    throw new Error("A credential format is required for Certify");
  }

  const payload = {
    entity_name: metadata.folderName?.trim() || "",
    certificate_name: metadata.certificateName?.trim() || "",
    certificate_description: metadata.certificateDescription?.trim() || "",
    preview_svg_url: getAssetUrl(assets.previewSvg),
    template_svg_url: getAssetUrl(assets.templateSvg),
    font_styles: fontStylesUrl,
  };

  if (issuerProject === ISSUER_PROJECT.CERTIFY) {
    payload.credential_format = credentialFormat;
  }

  return payload;
}
